import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { getCostText, getCostDataAid } from '../utils/getCostInfo';
import StrikeThroughPrice from './StrikeThroughPrice';
import { costTypes } from '../constants/costTypes';

export default class ServiceCost extends Component {
  render() {
    const { Element } = UX2.Element;
    const { service, staticContent, styles, isOlaStrikeThroughPriceExperimentEnabled } = this.props;
    const costText = getCostText(service, staticContent);
    const isStrikeThroughDisplayed =
      service.cost_type === costTypes.COST && isOlaStrikeThroughPriceExperimentEnabled;

    return (
      <Element data-aid={ getCostDataAid(service) } style={ styles }>
        { !isStrikeThroughDisplayed && costText }
        { isStrikeThroughDisplayed && (
          <StrikeThroughPrice service={ service } staticContent={ staticContent } />
        ) }
      </Element>
    );
  }
}

ServiceCost.propTypes = {
  service: PropTypes.object.isRequired,
  staticContent: PropTypes.object.isRequired,
  isOlaStrikeThroughPriceExperimentEnabled: PropTypes.bool,
  styles: PropTypes.object
};
